import { useEffect, useState } from "react";

/**
 * A live media query: `false` on the server and on the hydration render (nothing
 * decided yet), then the real answer, updated on every `change`. Anything a hook
 * decides arrives after hydration — a component whose FIRST paint depends on the
 * width keeps that decision in CSS and uses this only for what CSS cannot express
 * (ARIA roles, which element owns the focus, whether a video is fetched at all).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    // jsdom and older embedded views have no matchMedia: the SSR answer stands.
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(query);
    setMatches(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}
